import {
	ERegistrationStep,
	ERegistrationStatus,
	ProgressStepsState,
} from '../enums/ERegistrationSteps';

export const getInitialProgressSteps = (): ProgressStepsState => ({
	[ERegistrationStep.BUSINESS]: ERegistrationStatus.PENDING,
	[ERegistrationStep.USER]: ERegistrationStatus.PENDING,
	[ERegistrationStep.CONFIGURING]: ERegistrationStatus.PENDING,
	[ERegistrationStep.FINALIZING]: ERegistrationStatus.PENDING,
});

export const generateUsername = (businessName: string): string => {
	return businessName.toLowerCase().replace(/[^a-z0-9]/g, '');
};

export const generatePassword = (username: string): string => {
	return `${username}123$`;
};

export const generateShareLink = (username: string, email: string, baseUrl: string): string => {
	return `${baseUrl}/share/${username}?source=${email}`;
};
